type Props = {
  value: string;
};

type Score = 0 | 1 | 2 | 3 | 4;

function score(pw: string): Score {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  if (s > 4) s = 4;
  return s as Score;
}

const labels: Record<Score, { text: string; color: string; bar: string }> = {
  0: { text: "noch leer", color: "text-ink-muted", bar: "bg-line" },
  1: { text: "sehr schwach", color: "text-danger", bar: "bg-danger" },
  2: { text: "schwach", color: "text-danger", bar: "bg-danger/70" },
  3: { text: "okay", color: "text-warning", bar: "bg-warning" },
  4: { text: "stark", color: "text-success", bar: "bg-success" },
};

export function PasswordStrength({ value }: Props) {
  const s = score(value);
  const meta = labels[s];
  const segments = [1, 2, 3, 4] as const;
  return (
    <div className="mt-2" aria-live="polite">
      <div className="flex gap-1">
        {segments.map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded ${i <= s ? meta.bar : "bg-line"}`}
          />
        ))}
      </div>
      <p className={`mt-1 text-caption ${meta.color}`}>Stärke: {meta.text}</p>
    </div>
  );
}
